/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import Grid from '../../../../../SharedModules/Table/TableGridWithFeatures';
import TableFilterHeader from '../../../../contactType/components/TableFilterHeader';
import { LABELER_TABLEHAD } from '../../utility/tableHeads';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../../SharedModules/AgGridUtilities/suppressNavigation';
import ViewHistoryComponent from '../../../../../SharedModules/MicroFrontend/ViewHistoryComponent';

const LabelerTableComponent = ({
  labelerTableData,
  setLabelerRow,
  className = '',
  fullScreen,
  setFullScreen,
}) => {
  const [gridApi, setGridApi] = useState(null);
  const [tableCount, setTableCount] = useState(0);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [keyValue, setKeyValue] = useState([]);
  const [showViewHistory, setShowViewHistory] = useState(false);

  useEffect(() => {
    setTableCount(gridApi && gridApi.getDisplayedRowCount());
  }, [gridApi, labelerTableData]);

  const handleFullScreenViewClick = () => {
    setFullScreen(!fullScreen);
  };

  const handleViewHistory = () => {
    setShowViewHistory(false);
    setKeyValue({});
  };

  return (
    <div className={`table-container fourRecords ${className}`}>
      <Grid
        gridHeight={fullScreen ? '100vh' : 350}
        fullScreenView={fullScreen}
        rowData={labelerTableData}
        columnDefs={LABELER_TABLEHAD}
        data-testid="onEditingStopped"
        enterMovesDown
        suppressCellFocus
        onCellFocused={onCellFocused}
        singleClickEdit={false}
        //navigateToNextCell={navigateToNextCell}
        //tabToNextCell={tabToNextCell}
        handleFullScreenViewClick={handleFullScreenViewClick}
        exportFile
        onSelect={(e) => {
          setLabelerRow(e.data);
        }}
        fileName="View Calc Interest - Labeler"
        navigateToNextCell={(params) => {
          const { key } = params.event;
          const isLastRow = params.nextRow === null;
          const isLastColumn = params.nextColumn === null;

          if (key === 'Tab' && isLastRow && !isLastColumn) {
            params.event.preventDefault();
            return params.api.getDisplayedRowAtIndex(0, 0);
          }
          return params;
        }}
      />

      {showViewHistory ? (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="RECORD_MAILING"
          keyValue={keyValue}
        />
      ) : null}
    </div>
  );
};

export default LabelerTableComponent;
